<template>
	<div>
		<title>分享有礼</title>
		<!--<count-down :endTime="nowt" :callback="countend" endText="已经结束了"></count-down>-->
		<!--<mt-button @click.native="getnow" type="default" style="width: 100%;color:#fff;background:#e9a727;">立即绑定</mt-button>-->
		<div v-if="$route.params.sharedata" class="share">
			<img src="/static/img/share@2x1212.png"/>
			<div style="margin-top:5vw;">
				<div>
					<p></p>
					<span>活动规则</span>
					<p></p>
				</div>
				<div class="textarea">
					<span>邀请一名新用户通过分享页进行预约，当他完成安装并对锁具进行套餐购买后，您会获得一张价值200元的优惠券。</span>
				</div>
				<div>
					<p></p>
					<span>活动步骤</span>
					<p></p>
				</div>
				<div class="textarea">
					<span>点击右上角分享按键，分享到朋友圈即可。</span>
				</div>
			</div>
		</div>
		<div v-if="!$route.params.sharedata && !user.id" class="share">
			<img src="/static/img/share@2x1212.png"/>
			<div>
				<mt-field type="tel" placeholder="请输入手机号" v-model="form.phone"></mt-field>
				<div style="margin-top:10px;">
					<mt-field type="tel" placeholder="请输入验证码" v-model="form.code">
						<div @click="getcode" class="code">
							<span>获取验证码</span>
						</div>
					</mt-field>
				</div>
				<div style="margin-top:20px;">
					<mt-button @click.native="ding" type="default" style="width: 100%;color:#fff;background:#e9a727;">立即绑定</mt-button>
				</div>
			</div>
			<div>
				<div>
					<p></p>
					<span>活动规则</span>
					<p></p>
				</div>
				<div class="textarea">
					<span>邀请一名新用户通过分享页进行预约，当他完成安装并对锁具进行套餐购买后，您会获得一张价值200元的优惠券。</span>
				</div>
				<div>
					<p></p>
					<span>活动步骤</span>
					<p></p>
				</div>
				<div class="textarea">
					<span>1、 输入“鸿利智能”APP注册的手机号</span>
					<span>2、 生成分享页面</span>
				</div>
			</div>
		</div>
		<div v-show="user.id" class="qr">
			<img src="/static/img/share@2x1212.png"/>
			<div>
				<div class="qrimg">
					<!--<canvas id="qrcode"></canvas>-->
					<img src="/static/img/hooply@2x1031.png"/>
				</div>
				<div class="qrtext">
					<span>鸿利锁业</span>
					<span>{{user.phone}}<router-link to="/shareUser"><span>修改>></span></router-link></span>
				</div>
				<div>
					<p></p>
					<span>活动规则</span>
					<p></p>
				</div>
				<div class="textarea">
					<span>邀请一名新用户通过分享页进行预约，当他完成安装并对锁具进行套餐购买后，您会获得一张价值200元的优惠券。</span>
				</div>
				<div>
					<p></p>
					<span>活动步骤</span>
					<p></p>
				</div>
				<div class="textarea">
					<span>1、 点击当前页面右上角菜单，选择发送给朋友或者分享到朋友圈</span>
					<span>2、 新用户通过该分享页预约并安装（新用户注册app时需使用预约时的手机号码）</span>
					<span>3、 当被推荐人完成第一笔套餐购买时将自动发送200元优惠券到“鸿利智能”APP</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { Field,Button,Toast } from 'mint-ui';
	import countDown from '@/components/countDown'
	//import QRCode from 'qrcode'
	export default {
		components:{countDown},
		computed: {
			
		},
		data() {
			return {
				form:{},
				user:{},
				nowt:'1540436921'
			}
		},
		methods: {
			countend(){
				console.log('回调')
			},
			getnow(){
				this.nowt=(Date.parse(new Date())/1000+60).toString()
				console.log(this.nowt)
			},
			ding() {
				if(!this.form.phone || !this.form.phone.length==11){
					return Toast({
						message:'请正确输入手机号',
					});
				}
				if(!this.form.code){
					return Toast({
						message:'请正确输入验证码',
					});
				}
				let form=this.form,self=this
				form.wx_open_id=localStorage.openid
				self.$store.dispatch('post',{u:'/wx/binging_phone',d:form}).then(function(res){
			    	if(res.err==0){
			    		self.getuser()
						return
			    	}
			    	Toast({
						message: res.data,
					});
				})
			},
			getcode(){
				if(this.form.phone && this.form.phone.length==11){
					this.$store.dispatch('post',{u:'/wx/send_to_code',d:{phone:this.form.phone}}).then(function(res){
				    	//新用户，无openid
				    	if(res.err==0){
				    		Toast({
								message:"请输入验证码后点击绑定！",
							});
				    		self.getuser()
							return
				    	}
				    	//已绑定用户，有openid
				    	if(res.err==1){
				    		Toast({
								message:"已绑定帐号，如需绑定当前微信，请输入验证码后点击绑定！",
								duration:2000
							});
				    		self.getuser()
							return
				    	}
				    	Toast({
							message: res.data,
						});
					})
				}else{
					Toast({
						message:'请正确输入手机号',
					});
				}
			},
			getuser(){
				let self=this
				if(this.$route.params.sharedata){
					return
				}
				self.$store.dispatch('post',{u:'/wx/query_open_id',d:{wx_open_id:localStorage.openid}}).then(function(res){
			    	if(res.err==0){
			    		self.user=res.data
			    		//初始化二维码
			    		let go=window.location.protocol+'//'+window.location.host+'/wxprior/'+res.data.id
			    		/*QRCode.toCanvas(document.getElementById("qrcode"),go, function (error) {
							if (error) console.error(error)
						})*/
			    		//初始化微信分享
			    		wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
							wx.updateAppMessageShareData({ 
								title:'你需要被关在门外多少次，才会觉醒……',
								desc:'让它来守护你吧',
								link:go,
								imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
							}, function(res) {
								
							});
							wx.updateTimelineShareData({ 
								title:'你需要被关在门外多少次，才会觉醒……',
								link:go,
								imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
							}, function(res) {
								
							});
							wx.onMenuShareAppMessage({
								title:'你需要被关在门外多少次，才会觉醒……',
								desc:'让它来守护你吧',
								link:go,
								imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
								type: '', 
								dataUrl: '', 
								success: function () {
								// 用户点击了分享后执行的回调函数
								}
							});
							wx.onMenuShareTimeline({
								title:'你需要被关在门外多少次，才会觉醒……',
								link:go,
								imgUrl: 'https://xhlzn.oss-cn-hangzhou.aliyuncs.com/share.jpg',
								success: function () {
								// 用户点击了分享后执行的回调函数
								},
							});
						});
						return
			    	}
			    	//res.err=0时，不处理
			    	if(res.err>1){
			    		Toast({
							message: res.data,
						});
			    	}
				})
			}
		},
		mounted() {
			this.getuser()
		}
	}
</script>
<style scoped>
	.share{
		width: 100vw;
		height: 100%;
		min-height: 100vh;
		background: #4389F2;
	}
	.share>img{
		width:100vw;
	}
	.share>div{
		width:80vw;
		margin: 0 auto;
		background: #99C4F9;
		border-radius:5px;
		margin-bottom:20px;
		padding: 6vw;
		text-align: center;
	}
	.share>div>div{
		color: #FFF;
	}
	.share>div>div>p{
		width:20vw;
		border-bottom:1px solid #FFF;
		display: inline-block;
		vertical-align: middle;
		margin:0 10px;
	}
	.share>div>div>span{
		font-size:16px;
	}
/*文本框*/
	.textarea{
		text-align: left;
		display: block;
	}
	.share .textarea>span{
		display: block;
		padding: 4px;
		line-height: 18px;
		color: #FFF !important;
		font-size: 12px !important;
	}
	.qr .textarea>span{
		display: block;
		padding: 4px;
		line-height: 18px;
		color: #999 !important;
		font-size: 12px !important;
	}
/*绑定成功*/
	.qr{
		width: 100vw;
		height: 100%;
		min-height: 100vh;
	}
	.qr>img{
		width:100vw;
	}
	.qr>div{
		color: #999;
		width:80vw;
		margin: 0 auto;
		margin-bottom:20px;
		padding: 6vw;
		text-align: center;
	}
	.qr>div>div>p{
		width:20vw;
		border-bottom:1px solid #999;
		display: inline-block;
		vertical-align: middle;
		margin:0 10px;
	}
	.qr>div>div>span{
		font-size:16px;
		color: #333;
	}
	.qrimg{
		background: #FFF;
		width: 40vw;
		height: 40vw;
		margin:-16vw auto 20px auto;
		box-shadow:0px 6px 6px rgba(158,158,158,0.2);
	}
	.qrimg>img{
		width: 40vw !important;
		height: 40vw !important;
	}
	.qrtext{
		margin-bottom: 20px;
	}
	.qrtext>span{
		display: block;
		font-size: 12px !important;
		color: #999 !important;
	}
	.qrtext>span:first-child{
		color: #333 !important;
		font-size: 16px !important;
	}
	.qrtext>span:last-child{
		color: #666 !important;
		font-size: 14px !important;
		line-height: 26px;
	}
	.qrtext>span:last-child span{
		margin-left:8px;
		color: #F6A400 !important;
	}
	/*验证码*/
	.code{
		padding-left:10px;
		height: 20px;
		border-left:1px solid #E5E5E5;
		vertical-align: middle;
	}
	.code>span{
		font-size: 14px;
		color: #F6A400;
	}
</style>


// WEBPACK FOOTER //
// src/views/share.vue